import React from 'react';
import { OrderForListing } from '../../../models/OrderForListing';
import { AssemblyStatus } from '../AssemblyStatus';
import { IExtraElementsInfo } from '../useOrdersTable';
import { BlankHeightBlock, BlankWidthBlock, Content, ExtraContent, ExtraData } from './styles';

export interface IExtraRowProps {
  extraElementsInfo?: IExtraElementsInfo;
  orderForListing?: OrderForListing;
  colSpan?: number;
}

export const ExtraRow: React.FC<IExtraRowProps> = ({
  extraElementsInfo,
  orderForListing,
  colSpan
}) => {

  if (!orderForListing) return null;

  const elements: any[] = [];

  if (extraElementsInfo?.displayAssemblyStatus) {
    elements.push(<AssemblyStatus key={`order-${orderForListing.order.id}-assembly-status`} order={orderForListing.order} statePrescriptionLog={orderForListing.statePrescriptionLog} />);
  }

  if (!elements.length) return null;

  return (
    <tr>
      <ExtraData colSpan={colSpan}>
        <ExtraContent>
          <BlankWidthBlock />
          <Content>
            {elements.map(element => (element))}
          </Content>
          <BlankWidthBlock />
        </ExtraContent>
        <BlankHeightBlock />
      </ExtraData>
    </tr>
  );

}